import { ModalSweetAlert } from '@components/general/Alertas/Alertas';
import { getOrdenesKueski } from '@helpers/httpRequests/httpRequestKueski/httpRequesKueski'
import { Box, IconButton } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import React, { useEffect, useMemo, useState } from 'react'
import { Col, Container, OverlayTrigger, Row, Tooltip, Button, Spinner } from 'react-bootstrap'
import { FaCheck, FaEdit, FaEye, FaPlus, FaSpinner, FaWindowClose } from 'react-icons/fa';
import CancelarOrdenKueski from './modales/CancelarOrdenKueski';
import getDateFromUnix from "@helpers/dates/getDateFromUnix/getDateFromUnix";


const DashboardOrdenesKueski = () => {

    const [ordenes, setOrdenes] = useState({});

    const [ordenCancelada, setOrdenCancelada] = useState(false);

    const [loading, setLoading] = useState(false);


    const handleCancelacion = (payment_id) => {
                ModalSweetAlert({
                    title: "",
                    html: <CancelarOrdenKueski payment_id={payment_id} setOrdenCancelada={setOrdenCancelada} />,
                    showConfirmButton: false,
                    showCloseButton: true,
                    width: "700px",
                    height: "850px"
                });
            };
    
     const columnas = useMemo(() => [
        {
          accessorKey: "order_id",
          header: "# Orden",
        },
        {
          accessorKey: "payment_id",
          header: "Intento de pago",
        },
        {
          accessorKey: "nombreCliente",
          header: "Nombre del cliente",
        },
        {
          accessorKey: "correoCliente",
          header: "correo",
        },
        {
          accessorKey: "descripcion",
          header: "Descripción",
        },
         {
          accessorKey: "monto",
          header: "Monto",
        },
        {
          accessorKey: "folioContrato",
          header: "Folio de contrato",
        },
        {
          accessorKey: "ordered_at",
          header: "Fecha de orden",
          Cell: ({ cell }) => (
                <div className="text-center">
                  <small>
                    <b>{getDateFromUnix(cell.row.original.ordered_at)}</b>
                  </small>
                </div>
              ),
        },
         {
          accessorKey: "estatus",
          header: "Estatus de la orden",
        },
      ]);

      const obtenerOrdenesKueski = async() => {
        setLoading(true);
        try {
            const {data} = await getOrdenesKueski();

            if(Array.isArray(data)){
                setOrdenes(data.reverse());
            }else{
                setOrdenes([data]);
            }

            if(ordenCancelada) {
              setOrdenCancelada(false);
            }

            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.log("Error al recuperar las ordenes de Kueski");
        }
    }


useEffect(() => {
    
    obtenerOrdenesKueski();

}, [])

useEffect(() => {
  if(ordenCancelada){
  
    obtenerOrdenesKueski();

  }
}, [ordenCancelada])



  return (
    <Container fluid>
        {loading ? (
          <Row className='justify-content-center'>
            <Col className='col-auto'>
              <Spinner variant='primary' />
            </Col>
          </Row>
        ): (
          <>
            <Row className="justify-content-start mb-4">
              <Col className="col-auto">
              <OverlayTrigger
                  key={"top"}
                  placement={"top"}
                  overlay={
                      <Tooltip id={`tootltip-cancel`}>
                      Actualizar
                      </Tooltip>
                  }
                  >
                    <Button onClick={obtenerOrdenesKueski} className="btn btn-primary"><FaSpinner /></Button>
                </OverlayTrigger>
              </Col>
            </Row>
            <Row className="mb-5">
                <Col>
                    <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columnas}
                data={ordenes}
                enableRowActions
                
                positionActionsColumn="last"
                renderRowActions={({ row, table }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    {row.original.estatus === 'orden_aceptada' ? (
                      <OverlayTrigger
                        key={"top"}
                        placement={"top"}
                        overlay={
                            <Tooltip id={`tootltip-cancel`}>
                            Cancelar orden
                            </Tooltip>
                        }
                        >
                            <IconButton
                            disabled={(row.original.status === "orden_creada" || row.original.status === "orden_denegada" || row.original.status === "orden_cancelada") ? true : false}
                            color="primary"
                            id={row.original.payment_id}
                            onClick={()=> handleCancelacion(row.original.payment_id)}
                            >
                                <FaWindowClose className="text-danger" />
                            </IconButton>
                      </OverlayTrigger>
                    ): (
                      <OverlayTrigger
                        key={"top"}
                        placement={"top"}
                        overlay={
                            <Tooltip id={`tootltip-cancel`}>
                            Orden finalizada
                            </Tooltip>
                        }
                        >
                            <FaPlus className="text-warning" />
                      </OverlayTrigger>
                    )}

                    {/* <IconButton
                      color="secondary"
                      id={row.original.payment_id}
                    >
                      <FaEdit className="text-primary" />
                    </IconButton> */}

                    
                  </Box>
                )}
              />
                </Col>
            </Row>
          </>
        )}
    </Container>
  )
}

export default DashboardOrdenesKueski